"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/modern_office_sunlit_workspace.png)]">
      {}
      <div className="absolute inset-0 bg-primary/10"></div>

      {}
      <div ref={ref} className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className={`transition-all duration-700 ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h1 className="text-foreground mb-6">
            Transform Your Business with Modern Solutions
          </h1>
          <p className="text-muted-foreground text-lg mb-8 max-w-2xl mx-auto">
            Streamline your operations and unlock growth with our cutting-edge cloud-based tools designed for modern businesses.
          </p>
          <Link to="#" className="inline-block">
            <Button size="lg" className="shadow-medium hover:shadow-strong hover:scale-105 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
              Get Started Today
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}